import { CourseDetailsSectionCombinedProps } from './types';

const usePresenter = (props: CourseDetailsSectionCombinedProps): CourseDetailsSectionCombinedProps => {
  return props;
};

export default usePresenter;
